import { render, staticRenderFns } from "./CrmRelative.vue?vue&type=template&id=237eca80&scoped=true"
import script from "./CrmRelative.vue?vue&type=script&lang=js"
export * from "./CrmRelative.vue?vue&type=script&lang=js"
import style0 from "./CrmRelative.vue?vue&type=style&index=0&id=237eca80&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237eca80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237eca80')) {
      api.createRecord('237eca80', component.options)
    } else {
      api.reload('237eca80', component.options)
    }
    module.hot.accept("./CrmRelative.vue?vue&type=template&id=237eca80&scoped=true", function () {
      api.rerender('237eca80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/CrmRelative.vue"
export default component.exports